<template>
  <div
    class="top-bar"
    :style="{
      paddingTop: user.isFullScreen ? '70px' : '20px',
      display: user.isGameStart ? 'none' : 'flex',
    }"
  >
    <WealthBox
      v-for="(item, index) in indicators"
      :key="index"
      :title="upperCaseFirst(item.publicId)"
      :src="icons[item.publicId]"
      :value="item.value"
      :indicator-icon-class="
        item.publicId === 'ticket' && useIndicators.ticketAnimation
          ? 'ticket-animation'
          : null
      "
      :ticket-animation="
        item.publicId === 'ticket' && useIndicators.ticketAnimation
      "
      :redesign="false"
      :is-coin-amount-changed="isCoinAmountChanged"
      :is-tether-amount-changed="isTetherAmountChanged"
      :is-gem-amount-changed="isGemAmountChanged"
      :is-ticket-amount-changed="isTicketAmountChanged"
      :is-blue-fire-amount-changed="isBlueFireAmountChanged"
      :assets-background-color-changed="colors[item.publicId]"
      particle="header-coin"
    />
  </div>
</template>

<script setup>
import Gem from '~/assets/images/gem.svg'
import Tether from '~/assets/images/tether.svg'
import Coin from '~/assets/images/coin.svg'
import Ticket from '~/assets/images/ticket.svg'
import BlueFire from '~/assets/images/blue-fire.svg'

const user = useUserStore()
const useIndicators = useIndicatorsStore()
const icons = {
  gem: Gem,
  ticket: Ticket,
  coin: Coin,
  tether: Tether,
  'blue-fire': BlueFire,
}

const colors = {
  gem: '#00A5FF80',
  ticket: '#B56CFF80',
  coin: '#FFC50080',
  tether: '#00d394b0',
  'blue-fire': '#00A5FF80',
}

await user.profile()

const profilePicture = computed(() => user.user.avatar.photoUrl)

const indicators = computed(() => {
  return useIndicators.indicators
})

const upperCaseFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.substring(1)
}

const tetherValue = computed(() => {
  return useIndicators.tetherValue
})
const isTetherAmountChanged = ref()
watch(tetherValue, (newVal, oldVal) => {
  newVal < oldVal
    ? (isTetherAmountChanged.value = 'decreaseTether')
    : (isTetherAmountChanged.value = 'increaseTether')
  setTimeout(() => {
    isTetherAmountChanged.value = null
  }, 3000)
})

const gemValue = computed(() => {
  return useIndicators.gemValue
})
const isGemAmountChanged = ref()
watch(gemValue, (newVal, oldVal) => {
  newVal < oldVal
    ? (isGemAmountChanged.value = 'decreaseGem')
    : (isGemAmountChanged.value = 'increaseGem')
  setTimeout(() => {
    isGemAmountChanged.value = null
  }, 3000)
})

const coinValue = computed(() => {
  return useIndicators.coinValue
})
const isCoinAmountChanged = ref()
watch(coinValue, (newVal, oldVal) => {
  if (newVal - oldVal < 10 && newVal - oldVal > 0) {
    isCoinAmountChanged.value = null
  } else if (newVal > oldVal) {
    isCoinAmountChanged.value = 'increaseCoin'
  } else if (newVal < oldVal) {
    isCoinAmountChanged.value = 'decreaseCoin'
  }
  if (isCoinAmountChanged.value) {
    setTimeout(() => {
      isCoinAmountChanged.value = null
    }, 3000)
  }
})

const ticketValue = computed(() => {
  return useIndicators.ticketValue
})
const isTicketAmountChanged = ref()
watch(ticketValue, (newVal, oldVal) => {
  newVal < oldVal
    ? (isTicketAmountChanged.value = 'decreaseTicket')
    : (isTicketAmountChanged.value = 'increaseTicket')
  setTimeout(() => {
    isTicketAmountChanged.value = null
  }, 3000)
})

const blueFireValue = computed(() => {
  return useIndicators.blueFireValue
})
const isBlueFireAmountChanged = ref()
watch(blueFireValue, (newVal, oldVal) => {
  newVal < oldVal
    ? (isBlueFireAmountChanged.value = 'decreaseBlueFire')
    : (isBlueFireAmountChanged.value = 'increaseBlueFire')
  setTimeout(() => {
    isBlueFireAmountChanged.value = null
  }, 3000)
})
</script>

<style lang="scss" scoped>
.top-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 15px;
  padding: 70px 20px 20px 20px;
  position: fixed;
  top: 0;
  z-index: 1000;
  background: $backgroundColor;
  max-width: $sm;

  &__photo-url {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    border: 1px solid #ffd801;
  }
}
</style>
